import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var UtencilsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("g", {
                        fillRule: "nonzero",
                        children: _jsx("path", {
                            d: "M11 3a1 1 0 011 1v5.807a1 1 0 01-.47.847c-1.034.648-1.854 1.025-2.53 1.12v9.003a1 1 0 01-1.993.117L7 20.777l.001-9.004c-.676-.094-1.497-.47-2.532-1.119a1 1 0 01-.46-.72L4 9.807V4a1 1 0 011.993-.117L6 4v5.24c.432.248.783.412 1.036.494L7 9.721V4a1 1 0 01.883-.993L8 3a1 1 0 01.993.883L9 4v5.721l.079-.027c.24-.09.55-.241.921-.453V4a1 1 0 011-1zM19.084 13.608a1 1 0 00.942-1.337L16.94 3.663C16.563 2.607 15 2.878 15 4v16.777a1 1 0 102 0v-7.17h2.084z"
                        })
                    })
                })
            })
        ]
    });
};
UtencilsIcon.isCarinaIcon = true;
export default UtencilsIcon;
